import { c as _c } from "react/compiler-runtime";
import { Button, IconButton, Menu, MenuSection, SingleSelectItem, SortDownIcon, SortUpIcon } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { TableEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";

/** Information about a sort direction */

/** Information about each sort direction */
const SORT_DIRECTION_INFO = {
  asc: {
    label: "Ascending",
    icon: <SortDownIcon />,
    newSortDirection: "desc"
  },
  desc: {
    label: "Descending",
    icon: <SortUpIcon />,
    newSortDirection: "asc"
  }
};
/**
 * Component that allows users to select a sort field and toggle between ascending and descending directions.
 */
export function SortSelector(t0) {
  const $ = _c(40);
  const {
    sortOptions,
    sortItem,
    setSortItem,
    subjectType,
    trackingViewMode: t1
  } = t0;
  const trackingViewMode = t1 === undefined ? "cards" : t1;
  const {
    trackEvent
  } = useTrackEvent();
  const [menuAnchor, setMenuAnchor] = useState(null);
  let t2;
  if ($[0] !== setSortItem || $[1] !== sortItem.field || $[2] !== sortItem.sort || $[3] !== subjectType || $[4] !== trackEvent || $[5] !== trackingViewMode) {
    t2 = function handleSortDirectionToggle() {
      const newSortDirection = SORT_DIRECTION_INFO[sortItem.sort].newSortDirection;
      trackEvent({
        name: TableEvents.sortItems,
        props: {
          subject: subjectType,
          sortBy: sortItem.field,
          sortOrder: newSortDirection,
          viewMode: trackingViewMode
        }
      });
      setSortItem({
        field: sortItem.field,
        sort: newSortDirection
      });
    };
    $[0] = setSortItem;
    $[1] = sortItem.field;
    $[2] = sortItem.sort;
    $[3] = subjectType;
    $[4] = trackEvent;
    $[5] = trackingViewMode;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleSortDirectionToggle = t2;
  let t3;
  if ($[7] !== setSortItem || $[8] !== subjectType || $[9] !== trackEvent || $[10] !== trackingViewMode) {
    t3 = function handleSortFieldChange(newField) {
      trackEvent({
        name: TableEvents.sortItems,
        props: {
          subject: subjectType,
          sortBy: newField,
          sortOrder: "asc",
          viewMode: trackingViewMode
        }
      });
      setSortItem({
        field: newField,
        sort: "asc"
      });
      setMenuAnchor(null);
    };
    $[7] = setSortItem;
    $[8] = subjectType;
    $[9] = trackEvent;
    $[10] = trackingViewMode;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleSortFieldChange = t3;
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "inline-flex",
      alignItems: "center",
      gap: 0.5,
      width: "fit-content"
    };
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = menuAnchor !== null;
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = event => setMenuAnchor(event.currentTarget);
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = menuAnchor !== null ? "action.selected" : undefined;
  let t8;
  if ($[14] !== t7) {
    t8 = {
      backgroundColor: t7
    };
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = SORT_DIRECTION_INFO[sortItem.sort];
  const t10 = sortOptions[sortItem.field];
  let t11;
  if ($[16] !== t10.label || $[17] !== t5 || $[18] !== t8 || $[19] !== t9.icon) {
    t11 = <Button variant="neutralGhost" size="s" data-testid="sort-label" aria-expanded={t5} onClick={t6} sx={t8} icon={t9.icon}>{t10.label}</Button>;
    $[16] = t10.label;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9.icon;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = menuAnchor !== null;
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setMenuAnchor(null);
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    };
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  const t15 = SORT_DIRECTION_INFO[sortItem.sort];
  let t16;
  if ($[23] !== handleSortDirectionToggle || $[24] !== t15.icon) {
    t16 = <MenuSection><Box sx={t14}>Sort by<IconButton onClick={handleSortDirectionToggle} size="s">{t15.icon}</IconButton></Box></MenuSection>;
    $[23] = handleSortDirectionToggle;
    $[24] = t15.icon;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== sortOptions) {
    t17 = Object.values(sortOptions);
    $[26] = sortOptions;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== handleSortFieldChange || $[29] !== sortItem.field || $[30] !== t17) {
    t18 = t17.map(option => <SingleSelectItem key={option.field} label={option.label} value={option.field} selectedValue={sortItem.field} onClick={() => handleSortFieldChange(option.field)} />);
    $[28] = handleSortFieldChange;
    $[29] = sortItem.field;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== menuAnchor || $[33] !== t12 || $[34] !== t16 || $[35] !== t18) {
    t19 = <Menu anchorEl={menuAnchor} open={t12} onClose={t13} minWidth="200px">{t16}{t18}</Menu>;
    $[32] = menuAnchor;
    $[33] = t12;
    $[34] = t16;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t11 || $[38] !== t19) {
    t20 = <Box sx={t4}>{t11}{t19}</Box>;
    $[37] = t11;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  return t20;
}